export default __webpack_public_path__ + "static/media/il.11d095d6.svg";